// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"107":"pages","161":"extensions-validation","215":"assets","772":"components-Saffron"}[chunkId] || chunkId) + "." + {"107":"99517efd","161":"c57faa9f","215":"4faa06eb","717":"8b6287e4","772":"f836b73d"}[chunkId] + ".css";
};